import Carousel from "nuka-carousel";

import { CheckeredContainer } from "ui/CheckeredContainer";
import { useI18n } from "utils/with-i18n.utils";

import { Reason } from "./Reason";
import WhirledArrowSVG from "./whirled-arrow.svg";

const REASONS = [
  {
    title: "club.reason.1.label",
    descriptionPart1: "club.reason.1.description.part1",
    descriptionPart2: "club.reason.1.description.part2",
  },
  {
    title: "club.reason.2.label",
    descriptionPart1: "club.reason.2.description.part1",
    descriptionPart2: "club.reason.2.description.part2",
  },
  {
    title: "club.reason.3.label",
    descriptionPart1: "club.reason.3.description.part1",
    descriptionPart2: "club.reason.3.description.part2",
  },
  {
    title: "club.reason.4.label",
    descriptionPart1: "club.reason.4.description.part1",
    descriptionPart2: "club.reason.4.description.part2",
  },
  {
    title: "club.reason.5.label",
    descriptionPart1: "club.reason.5.description.part1",
    descriptionPart2: "club.reason.5.description.part2",
  },
];

export const Reasons = () => {
  const i18n = useI18n();

  return (
    <CheckeredContainer className="flex relative flex-col items-center pb-16">
      <div className="flex absolute -top-5 grow ml-12">
        <p className="self-start py-1 mr-4 text-xl font-extrabold bg-yellow -rotate-3 lg:text-3xl">
          {i18n.t("club.reason.proof")}
        </p>
        <WhirledArrowSVG className="mt-4" />
      </div>

      <div className="hidden flex-wrap gap-x-4 gap-y-10 justify-center mt-28 max-w-5xl lg:flex">
        {REASONS.map(({ descriptionPart1, descriptionPart2, title }, index) => (
          <Reason
            key={index}
            reasonNumber={index + 1}
            descriptionPart1={descriptionPart1}
            descriptionPart2={descriptionPart2}
            title={title}
          />
        ))}
      </div>

      <div className="flex flex-col max-w-full lg:hidden">
        <Carousel
          className="mt-20"
          defaultControlsConfig={{
            nextButtonClassName: "hidden",
            prevButtonClassName: "hidden",
            pagingDotsContainerClassName:
              "gap-2 [&>*]:border-2 [&>*]:border-light-gray [&>*]:relative [&>*]:rounded-full [&>*]:w-4 [&>*]:h-4 [&>*]:bg-light-gray [&>.active]:bg-yellow [&>.active]:border-black ",
            pagingDotsStyle: {
              fill: "transparent",
              top: 0,
              left: 2,
              right: 0,
              bottom: 0,
              position: "absolute",
            },
          }}
        >
          {REASONS.map(
            ({ descriptionPart1, descriptionPart2, title }, index) => (
              <div key={index} className="flex justify-center">
                <Reason
                  reasonNumber={index + 1}
                  descriptionPart1={descriptionPart1}
                  descriptionPart2={descriptionPart2}
                  title={title}
                />
              </div>
            ),
          )}
        </Carousel>
      </div>
    </CheckeredContainer>
  );
};
